import Swiper from 'swiper';
import 'swiper/css';
import 'swiper/css/navigation';
import 'swiper/css/pagination';
import { Manipulation, Navigation, Pagination } from 'swiper/modules';
export default class CategoryHero {
    constructor() {
        this.slider = document.querySelector('.swiper--category-hero');

        this.sliderActiveIndex = +this.slider.querySelector('.slideCategoryActive').dataset.slideactive;

        this.navigationPrev = document.querySelector('.slider-button-prev--category-hero');
        this.navigationNext = document.querySelector('.slider-button-next--category-hero');

        this.ready();
    }

    ready() {
        const swiper = new Swiper(this.slider, {
            modules: [Navigation, Pagination, Manipulation],
            loop: true,
            initialSlide: this.sliderActiveIndex,
            centeredSlides: true,
            grabCursor: true,
            slidesPerView: 2,
            allowTouchMove: true,
            centerInsufficientSlides: true,
            navigation: {
                nextEl: this.navigationNext,
                prevEl: this.navigationPrev,
            },
            breakpoints: {
                0: {
                    slidesPerView: 1,
                },
                1024: {
                    slidesPerView: 2,
                },
            },
        });

        // swiper.on('slideChangeTransitionEnd', () => {
        //     const newUrl = this.slider.querySelector('.swiper-slide-active').dataset.url;
        //     window.location.href = newUrl;
        // });
    }
}
if (document.querySelector('.page-content-category-hero')) {
    new CategoryHero();
}
